import { createRestAPIModelGenerator } from 'src/data/models/generator';
export const TYPE = 'feedback-types';

const FeedbackTypesGenerator = createRestAPIModelGenerator(TYPE);
export default FeedbackTypesGenerator.createValueListModel();
